<template>
    <Head title="Authorization to Release Information" />

    <GuestLayout>
        <div class="min-h-screen bg-white py-8 px-4 sm:px-6">
            <div class="mx-auto max-w-lg">
                <div class="mb-8">
                    <JetAuthenticationCardLogoColored class="h-10 w-auto" />
                </div>

                <h1 class="text-2xl font-bold text-gray-900">Authorization to release information</h1>

                <div class="mt-8 space-y-6 text-sm text-gray-700">
                    <div>
                        <p class="font-semibold text-gray-900">Authorized reference</p>
                        <p class="mt-1">{{ verification.reference_name }}</p>
                        <p>{{ verification.reference_email }}</p>
                    </div>

                    <div>
                        <p class="font-semibold text-gray-900">Reference type</p>
                        <p class="mt-1">{{ verification.reference_type_label }}</p>
                    </div>

                    <div class="rounded-lg bg-gray-100 px-4 py-3">
                        <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Applicant</p>
                        <p class="mt-1 text-lg font-semibold text-gray-900">{{ verification.applicant_name }}</p>
                    </div>

                    <p class="leading-relaxed">
                        I, {{ verification.applicant_name }}, authorize the release of information about my rental or employment history as part of my rental application. This information may be shared through RentRisk for the purpose of verifying the details I provided.
                    </p>

                    <div v-if="authorizationSignature" class="pt-4">
                        <p class="text-xs font-medium uppercase tracking-wide text-gray-500">Signature</p>
                        <img :src="authorizationSignature" alt="Applicant signature" class="mt-2 h-20 w-auto" />
                        <p v-if="authorizationAt" class="mt-3 text-xs text-gray-500">
                            {{ authorizationAt }} · Via RentRisk screening software
                        </p>
                    </div>
                </div>

                <div class="mt-8 text-center">
                    <Link
                        :href="route('reference-verification.show', verification.token)"
                        class="text-sm text-rent-risk-blue-400 underline hover:text-rent-risk-blue-500"
                    >
                        Back to verification form
                    </Link>
                </div>
            </div>
        </div>
    </GuestLayout>
</template>

<script>
import GuestLayout from '@/Layouts/V2/GuestLayout.vue';
import JetAuthenticationCardLogoColored from '@/Jetstream/AuthenticationCardLogoColored.vue';
import { Head, Link } from '@inertiajs/vue3';

export default {
    components: {
        GuestLayout,
        JetAuthenticationCardLogoColored,
        Head,
        Link,
    },
    props: {
        verification: { type: Object, required: true },
        authorizationSignature: { type: String, default: null },
        authorizationAt: { type: String, default: null },
    },
};
</script>
